import { render, staticRenderFns } from "./manage-outs.vue?vue&type=template&id=24da94cb&scoped=true"
import script from "./manage-outs.vue?vue&type=script&lang=js"
export * from "./manage-outs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24da94cb",
  null
  
)

export default component.exports